var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXs96(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    height: 382,
    id: "svg_5",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 382,
    x: 8.5,
    y: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    height: 239.99999,
    id: "svg_6",
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 5,
    width: 239.99999,
    x: 79,
    y: 46.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_7",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 79.5,
    xmlSpace: "preserve",
    y: 31.5
  }, "Hakaru+"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 16,
    fontWeight: "bold",
    id: "svg_8",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 343,
    xmlSpace: "preserve",
    y: 31.5
  }, "XS-96"), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5,
    cy: 339.5,
    fill: "#56aaff",
    id: "svg_9",
    rx: 18,
    ry: 8,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_10",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 202,
    xmlSpace: "preserve",
    y: 360.5
  }, "SET      +         -      RESET             PROG"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontFamily: "Roboto",
    fontSize: 14,
    fontWeight: "normal",
    id: "svg_11",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 200,
    xmlSpace: "preserve",
    y: 327
  }, "I        V/F    P/Q/S     PF  MAX/AVG   E"), /*#__PURE__*/React.createElement("ellipse", {
    cx: 123,
    cy: 339.5,
    fill: "#56aaff",
    id: "svg_12",
    rx: 18,
    ry: 8,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 339.5,
    fill: "#56aaff",
    id: "svg_13",
    rx: 18,
    ry: 8,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225,
    cy: 339.5,
    fill: "#56aaff",
    id: "svg_14",
    rx: 18,
    ry: 8,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 276,
    cy: 339.5,
    fill: "#56aaff",
    id: "svg_15",
    rx: 18,
    ry: 8,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 329,
    cy: 339.5,
    fill: "#56aaff",
    id: "svg_16",
    rx: 18,
    ry: 8,
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Monospace",
    fontSize: 36,
    fontWeight: "bold",
    id: "svg_18",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 238.41406,
    xmlSpace: "preserve",
    y: 105.5
  }, "5.000 A"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Monospace",
    fontSize: 36,
    fontWeight: "bold",
    id: "svg_19",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 238.78906,
    xmlSpace: "preserve",
    y: 160.5
  }, "5.000 A"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Monospace",
    fontSize: 36,
    fontWeight: "bold",
    id: "svg_20",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 238.78906,
    xmlSpace: "preserve",
    y: 216.5
  }, "5.000 A"), /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fontFamily: "Monospace",
    fontSize: 26,
    fontWeight: "bold",
    id: "svg_21",
    stroke: "#000000",
    strokeDasharray: "null",
    strokeLinecap: "null",
    strokeLinejoin: "null",
    strokeOpacity: 0,
    strokeWidth: 0,
    textAnchor: "middle",
    x: 201.78906,
    xmlSpace: "preserve",
    y: 267.5
  }, "103685 kWh"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXs96);
export default __webpack_public_path__ + "static/media/xs96.617d2e4c.svg";
export { ForwardRef as ReactComponent };